import React, { useEffect, useState } from 'react';
import { projectMilestoneServices } from '../../../APIServices/projectMilestoneServices';
import Pagination from '../../../hooks/Pagination';

function DeletedProjectMilestoneHistory({
  getProjectMilestoneData,
  setModalOpen,
  deletedPageNumber,
  setDeletedPageNumber,
  deletedItemsPerPage,
  setDeletedItemsPerPage,
  deleteProjectMilestoneList,
  deleteProjectMilestoneCount,
  getDeletedProjectMilestoneData,
}) {
  const [buttonLoader, setButtonLoader] = useState(false);
  const totalPage = Math.ceil(deleteProjectMilestoneCount / deletedItemsPerPage);

  const softDeleteRestoreProjectMilestone = async (id) => {
    setButtonLoader(true);
    const data = await projectMilestoneServices.softDeleteRestoreProjectMilestone({
      id,
      type: 'restore',
    });
    if (data?.statusCode === 200) {
      getProjectMilestoneData();
      getDeletedProjectMilestoneData();
    }
    setButtonLoader(false);
  };

  const deleteProjectMilestoneData = async (id) => {
    setButtonLoader(true);
    const data = await projectMilestoneServices.deleteProjectMilestoneData({ id });
    if (data?.statusCode === 200) {
      getDeletedProjectMilestoneData();
    }
    setButtonLoader(false);
  };

  useEffect(() => {
    getDeletedProjectMilestoneData();
  }, [deletedPageNumber, deletedItemsPerPage]);

  return (
    <div className="modal-backdrop" onClick={() => setModalOpen('')}>
      <div className="modal" style={{ maxWidth: 620 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <div>
            <div className="modal-title">Deleted Project Milestone List</div>
            <div className="xs muted">Restore and permanent delete project milestones</div>
          </div>
          <button className="icon-btn" onClick={() => setModalOpen('')}>
            <i className="ti ti-x" />
          </button>
        </div>

        <div className="modal-body">
          <table className="tbl">
            <thead>
              <tr>
                <th>Project Milestone</th>
                <th style={{ width: 140 }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {deleteProjectMilestoneList.map((item) => (
                <tr key={item._id}>
                  <td className="medium">{item.projectMilestone}</td>
                  <td>
                    <div className="flex gap-2">
                      <button
                        className="icon-btn"
                        title="Restore"
                        style={{ color: 'var(--info)' }}
                        onClick={() => softDeleteRestoreProjectMilestone(item?._id)}
                        disabled={buttonLoader}
                      >
                        <i className="ti ti-rotate" />
                      </button>
                      <button
                        className="icon-btn"
                        title="Permanent Delete"
                        style={{ color: 'var(--danger)' }}
                        onClick={() => deleteProjectMilestoneData(item?._id)}
                        disabled={buttonLoader}
                      >
                        <i className="ti ti-trash-x" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <Pagination
            itemsPerPage={deletedItemsPerPage}
            setItemsPerPage={setDeletedItemsPerPage}
            pageNumber={deletedPageNumber}
            setPageNumber={setDeletedPageNumber}
            totalPage={totalPage}
            totalItems={deleteProjectMilestoneCount}
          />
        </div>
      </div>
    </div>
  );
}

export default DeletedProjectMilestoneHistory;
